import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { ReportTypes } from "../../../interfaces/Reports";

const ReportOutlet = lazy(() => import("../components/ReportOutlet"));

const Reports = lazy(() => import("../components/Report"));

const ReportsRoute: RouteObject = {
  path: "/reports",
  element: <ReportOutlet />,
  children: [
    {
      path: "leads/overall-lead",
      element: <Reports type={ReportTypes.OVERALL_LEAD_REPORT} />,
    },
    {
      path: "leads/lead-history",
      element: <Reports type={ReportTypes.LEAD_HISTORY_REPORT} />,
    },
    {
      path: "leads/store-status",
      element: <Reports type={ReportTypes.STORE_STATUS_ACTIVITY} />,
    },
    {
      path: "leads/store-category",
      element: <Reports type={ReportTypes.STORE_CATEGORY_REPORT} />,
    },
    {
      path: "leads/store-efficiency",
      element: <Reports type={ReportTypes.STORE_EFFICIENCY_REPORT} />,
    },
    {
      path: "leads/store-person-efficiency",
      element: <Reports type={ReportTypes.STORE_PERSON_EFFICIENCY_REPORT} />,
    },
    {
      path: "leads/source-efficiency",
      element: <Reports type={ReportTypes.SOURCE_EFFICIENCY_REPORT} />,
    },
    {
      path: "leads/product-efficiency",
      element: (
        <Reports type={ReportTypes.PRODUCT_HIERARCHY_EFFICIENCY_REPORT} />
      ),
    },
    {
      path: "leads/lead-telecall",
      element: (
        <Reports type={ReportTypes.LEAD_TELECALL_REPORT} />
      ),
    },
    {
      path: "transaction",
      element: <Reports type={ReportTypes.TRANSACTION} />,
    },
    { path: "fraud", element: <Reports type={ReportTypes.FRAUD_REPORT} /> },
    {
      path: "enrollment",
      element: <Reports type={ReportTypes.MEMBER_BILL_REPORT} />,
    },
    { path: "offer", element: <Reports type={ReportTypes.OFFER_REPORT} /> },
    {
      path: "offer-redemption",
      element: <Reports type={ReportTypes.OFFER_REDEMPTION_REPORT} />,
    },
    {
      path: "offer-earn",
      element: <Reports type={ReportTypes.OFFER_EARN_REPORT} />,
    },
    {
      path: "store-health",
      element: <Reports type={ReportTypes.STORE_HEALTH_REPORT} />,
    },
    {
      path: "store-kpi",
      element: <Reports type={ReportTypes.STORE_KPI_REPORT} />,
    },
    {
      path: "loyalty-liability",
      element: <Reports type={ReportTypes.LIABILITY_SUMMARY_REPORT} />,
    },
    {
      path: "kpi",
      element: <Reports type={ReportTypes.KPI_REPORT} />,
    },
    {
      path: "overall-campaign",
      element: <Reports type={ReportTypes.OVERALL_CAMPAIGN_REPORT} />,
    },
    {
      path: "survey",
      element: <Reports type={ReportTypes.SURVEY_RESPONSE_REPORT} />,
    },
    {
      path: "friend-referral",
      element: <Reports type={ReportTypes.FRIEND_REFERRAL_REPORT} />,
    },
    {
      path: "pwa-enrolment",
      element: <Reports type={ReportTypes.PWA_ENROLMENT_REPORT} />
    },
    {
      path: "ecommerce/product-views",
      element: <Reports type={ReportTypes.ECOM_PRODUCT_VIEWS_REPORT} />
    },
    {
      path: "ecommerce/cart-items",
      element: <Reports type={ReportTypes.ECOM_CART_ITEMS_REPORT} />
    },
    {
      path: "ecommerce/landing-events",
      element: <Reports type={ReportTypes.ECOM_LANDING_EVENTS_REPORT} />
    },
    {
      path: "ecommerce/summary",
      element: <Reports type={ReportTypes.ECOM_SUMMARY_REPORT} />
    },
    {
      path: "social-media-campaigns",
      element: <Reports type={ReportTypes.SOCIAL_MEDIA_CAMPAIGNS_REPORT} />
    },
    {
      path: "ticket-desk/ticket-export",
      element: <Reports type={ReportTypes.TICKET_EXPORT} />
    },
  ],
};

export default ReportsRoute;
